/**
 * CombatState — per-battle overlay for the player.
 *
 * Holds combat-only resources that reset each battle:
 * AP, armor, and eventually buffs/debuffs.
 *
 * Created by CombatManager at battle start. Discarded at battle end.
 */
export class CombatState {
  ap: number;
  readonly maxAp: number;
  armor: number;

  constructor(maxAp: number = 3) {
    this.maxAp = maxAp;
    this.ap = maxAp;
    this.armor = 0;
  }

  spendAp(amount: number = 1): boolean {
    if (this.ap < amount) return false;
    this.ap -= amount;
    return true;
  }

  get apRemaining(): boolean {
    return this.ap > 0;
  }

  resetAp(): void {
    this.ap = this.maxAp;
  }

  /** Apply damage through armor first. Returns actual HP damage. */
  applyDamage(rawDamage: number): number {
    const absorbed = Math.min(this.armor, rawDamage);
    this.armor -= absorbed;
    return rawDamage - absorbed;
  }

  /** Reset per-turn state (AP refill, armor clears). */
  startTurn(): void {
    this.resetAp();
    this.armor = 0;
  }
}
